<template>
  <div id="page-geofence">
    <el-amap
      ref="geoFenceAmap"
      vid="geoFenceAmap"
      class="geo-fence-amap"
      :center="center"
      :zoom="zoom"
      :zooms="[3, 20]"
      :plugin="plugin"
      :events="events"
    >
      <el-amap-polygon
        v-for="(polygon, index) in polygons"
        :vid="index"
        :ref="`polygon_${index}`"
        :key="index"
        :path="polygon.path"
        :events="polygon.events"
        :extData="polygon.extData"
        :fillColor="polygon.fillColor"
        :fillOpacity="polygon.fillOpacity"
        :strokeColor="polygon.strokeColor"
        :strokeWeight="polygon.strokeWeight"
        :strokeOpacity="polygon.strokeOpacity"
      >
      </el-amap-polygon>

      <el-amap-marker v-for="(marker, index) in markers" :key="index" :position="marker">
      </el-amap-marker>
    </el-amap>

    <div class="fence-panel fence-query-panel">
      <el-amap-search-box
        class="search-input-box"
        :search-option="searchOption"
        :on-search-result="amapSearchResultHandle"
      >
      </el-amap-search-box>
    </div>

    <div class="tool-btns-panel">
      <ul>
        <li title="添加围栏" :class="{ active: isCanAddFence }" @click="addFenceHandle">
          <i class="el-icon-plus tool-btn"></i>
        </li>

        <li title="删除围栏" :class="{ active: isCanDeleteFence }" @click="deleteFenceHandle">
          <i class="el-icon-delete tool-btn"></i>
        </li>
      </ul>
    </div>

    <div class="fence-panel right-layer-panel">
      <el-collapse class="no-border">
        <el-collapse-item title="图层管理" name="1">
          <el-collapse accordion v-if="Object.keys(menuLayerData).length > 0">
            <el-checkbox-group
              v-model="checkedFenceLayerList"
              @change="checkFenceLayerChangeHandle"
            >
              <el-collapse-item
                v-for="(item, index) in Object.keys(menuLayerData)"
                :title="layerStateMap[index] || layerStateMap['default']"
                :name="layerStateMap[index] || index"
                :key="layerStateMap[index] || index"
                class="fence-layer-item-wrap"
              >
                <div
                  class="fence-layer-item"
                  v-for="item2 in menuLayerData[item]"
                  :key="item2.code || ''"
                >
                  <el-checkbox
                    :value="item2.code || ''"
                    :label="item2.code || ''"
                    :title="item2.name || item2.nameEn || ''"
                    >{{ item2.name || item2.nameEn || '' }}</el-checkbox
                  >
                  <el-button
                    v-show="index > 0"
                    size="mini"
                    type="text"
                    :class="{ active: item2.isEdit || false }"
                    :code="item2.code || ''"
                    @click="editFenceToggleHandle(item2.code || '')"
                    >编辑</el-button
                  >
                </div>
              </el-collapse-item>
            </el-checkbox-group>
          </el-collapse>
        </el-collapse-item>
      </el-collapse>
    </div>

    <el-dialog title="操作" width="30%" :visible.sync="deleteFenceDialogVisible">
      <div>{{ deleteFencePromptText }}</div>

      <div slot="footer">
        <el-button @click="deleteFenceDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="deleteFenceConfirmHandle">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="错误"
      width="30%"
      :show-close="dialogIsCloseBoolean"
      :visible.sync="errorDialogVisible"
      :close-on-click-modal="dialogIsCloseBoolean"
      :close-on-press-escape="dialogIsCloseBoolean"
    >
      <div>{{ dialogErrorMessage || '未知错误' }}</div>

      <div slot="footer">
        <el-button type="primary" @click="errorDialogConfirmHandle">{{
          dialogBtnTextMap[dialogErrorType]
        }}</el-button>
      </div>
    </el-dialog>

    <el-drawer
      ref="fenceInfoDrawer"
      direction="rtl"
      :title="fenceInfoDrawerType === 'add' ? '添加围栏' : isEditFence ? '编辑围栏' : '围栏信息'"
      :visible.sync="fenceInfoDrawerVisible"
      @close="fenceCancelHandle(true)"
    >
      <div class="drawer-content">
        <el-form
          ref="fenceForm"
          :model="fenceFormData"
          :rules="fenceFormRules"
          :label-width="formLabelWidth"
        >
          <el-form-item label="围栏ID" v-if="fenceInfoDrawerType !== 'add'">
            <span>{{ rightClickFenceData.id || '' }}</span>
          </el-form-item>

          <el-form-item label="围栏名称" prop="name">
            <el-input
              v-model="fenceFormData.name"
              :disabled="!isEditFence"
              placeholder="请输入围栏名称"
            ></el-input>
          </el-form-item>

          <el-form-item v-if="fenceInfoDrawerType === 'add'" label="所属区域">
            {{ fenceFormData.cityName }}
          </el-form-item>

          <el-form-item v-else label="所属区域">
            <!-- <filter-region :value.sync="fenceFormData.cityCode" disabled /> -->
            <filter-businessline-region :value.sync="fenceFormData.cityCode" businessLine="2" disabled />
          </el-form-item>

          <el-form-item label="围栏描述">
            <el-input
              type="textarea"
              v-model="fenceFormData.explain"
              :disabled="!isEditFence"
              :autosize="{ minRows: 2, maxRows: 2 }"
              placeholder="请输入围栏描述"
            ></el-input>
          </el-form-item>

          <el-form-item label="围栏中心点" v-if="fenceInfoDrawerType !== 'add'">
            <span>{{
              (rightClickFenceData.centerLng || 0) + ',' + (rightClickFenceData.centerLat || 0)
            }}</span>
          </el-form-item>

          <el-form-item label="围栏面积" v-if="fenceInfoDrawerType !== 'add'">
            <span>{{ (rightClickFenceData.area || 0) + ' 平方米' }}</span>
          </el-form-item>

          <el-form-item label="图层名称">
            <span>{{
              fenceInfoDrawerType === 'add'
                ? selectedFenceLayer.name || ''
                : rightClickFenceLayer.name || ''
            }}</span>
          </el-form-item>
        </el-form>

        <div class="drawer-footer">
          <el-button @click="fenceCancelHandle(true)">取 消</el-button>
          <el-button type="primary" :loading="loading" @click="fenceSubmitHandle('fenceForm')">{{
            loading ? '保存中...' : '确 定'
          }}</el-button>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
const iconMap = {
  0: 'https://s3.meituan.net/static-prod01/com.sankuai.bike.web.polarish5-files/spock_marker_0.png',
  1: 'https://s3.meituan.net/static-prod01/com.sankuai.bike.web.polarish5-files/spock_marker_1.png',
  2: 'https://s3.meituan.net/static-prod01/com.sankuai.bike.web.polarish5-files/spock_marker_2.png',
  3: 'https://s3.meituan.net/static-prod01/com.sankuai.bike.web.polarish5-files/spock_marker_3.png',
  4: 'https://s3.meituan.net/static-prod01/com.sankuai.bike.web.polarish5-files/spock_marker_4.png',
  default: 'https://s3.meituan.net/static-prod01/com.sankuai.bike.web.polarish5-files/poi-marker-default.png',
  marker_mid: 'https://s3.meituan.net/static-prod01/com.sankuai.bike.web.polarish5-files/marker_mid.png',
  marker_end: 'https://s3.meituan.net/static-prod01/com.sankuai.bike.web.polarish5-files/marker_end.png',
  marker_start: 'https://s3.meituan.net/static-prod01/com.sankuai.bike.web.polarish5-files/marker_start.png',
}

const colorMap = {
  line1: '#56c0e4',
  line2: '#ff33ff',
  default: '#ff4612',
  selected: '#409eff',
}

const MAX_PAGE_SIZE = 2000

export default {
  name: 'GeoFence',
  data() {
    return {
      zoom: 12,
      center: [116.397617, 39.910993],
      events: {
        init: (map) => {
          let that = this
          let mapCenter = map.getCenter()
          let mapCenterLng = mapCenter.getLng() || 116.397617
          let mapCenterLat = mapCenter.getLat() || 39.910993

          that.center = [mapCenterLng, mapCenterLat]
          that.mapInstance = map

          map.getCity((data) => {
            console.log('getCity data: ', data)
          })

          AMap.plugin(['AMap.MouseTool', 'AMap.PolyEditor', 'AMap.RangingTool'], () => {
            let mouseTool = new AMap.MouseTool(map)
            let rangingTool = new AMap.RangingTool(map, {
              lineOptions: {
                strokeStyle: 'solid',
                strokeColor: colorMap['line2'],
                strokeWeight: 2,
                strokeOpacity: 1,
              },
              midMarkerOptions: {
                icon: new AMap.Icon({
                  size: new AMap.Size(19, 31),
                  image: iconMap['marker_mid'],
                  imageSize: new AMap.Size(19, 31),
                }),
                offset: new AMap.Pixel(-9, -31),
              },
              endMarkerOptions: {
                icon: new AMap.Icon({
                  size: new AMap.Size(19, 31),
                  image: iconMap['marker_end'],
                  imageSize: new AMap.Size(19, 31),
                }),
                offset: new AMap.Pixel(-9, -31),
              },
              startMarkerOptions: {
                icon: new AMap.Icon({
                  size: new AMap.Size(19, 31),
                  image: iconMap['marker_start'],
                  imageSize: new AMap.Size(19, 31),
                }),
              },
            })

            that.mouseToolInstance = mouseTool
            that.rangingToolInstance = rangingTool

            AMap.event.addListener(rangingTool, 'addnode', function (e) {
              console.log('rangingTool addnode e: ', e)
            })
            AMap.event.addListener(rangingTool, 'removenode', that.updateLineNodeHandle)
            AMap.event.addListener(rangingTool, 'end', that.updateLineNodeHandle)
          })
        },
        moveend: () => {
          console.log('map moveend')
        },
        zoomchange: () => {
          console.log('map zoomchange')
        },
        click: () => {
          console.log('map clicked')
        },
      },
      plugin: [
        {
          pName: 'ToolBar',
          position: 'LB',
          liteStyle: true,
          events: {
            init(instance) {
              console.log('ToolBar instance: ', instance)
            },
          },
        },
        {
          pName: 'Scale',
          events: {
            init(instance) {
              console.log('Scale instance: ', instance)
            },
          },
        },
        // {
        //   pName: 'MapType',
        //   defaultType: 0,
        //   events: {
        //     init(instance) {
        //       console.log('MapType instance: ', instance)
        //     },
        //   },
        // },
      ],
      loading: false,
      markers: [],
      polygons: [],
      isAddFence: false,
      isEditFence: false,
      mapInstance: null,
      searchOption: {
        city: '全国',
        citylimit: false,
      },
      layerStateMap: {
        0: '已审核',
        1: '待审核',
        default: '未知图层',
      },
      menuLayerData: {},
      fenceFormData: {
        name: '',
        explain: '',
        cityCode: '',
        cityName: '',
      },
      fenceFormRules: {
        name: [
          {
            trigger: 'blur',
            message: '请输入围栏名称',
            required: true,
          },
        ],
        cityCode: [
          {
            trigger: 'blur',
            message: '请选择所属区域',
            required: true,
          },
        ],
      },
      spockCityList: [],
      isCanAddFence: false,
      isOperateFence: false,
      formLabelWidth: '84px',
      dialogErrorType: 0,
      fenceCoordinates: [],
      isCanDeleteFence: false,
      dialogBtnTextMap: {
        0: '确 定',
        1: '重 画',
        2: '重新编辑',
        3: '确 定',
        4: '确 定',
      },
      mouseToolInstance: null,
      dialogErrorMessage: '',
      selectedFenceLayer: {},
      errorDialogVisible: false,
      rangingToolInstance: null,
      fenceInfoDrawerType: 'add',
      rightClickFenceData: {},
      rightClickFenceLayer: {},
      selectedGeoFenceList: [],
      dialogIsCloseBoolean: false,
      checkedFenceLayerList: [],
      deleteFencePromptText: '',
      fenceInfoDrawerVisible: false,
      deleteFenceDialogVisible: false,
      rightClickSelectedPolygon: null,
    }
  },
  created() {
    this.getLayerList()
  },
  methods: {
    getLayerList() {
      let that = this
      let params = {
        regionalType: 1,
        businessTypes: '3,8',
      }

      this.fetch
        .get('geofenceFenceMenu', { params })
        .then((res) => {
          let { data } = res

          if (data && Object.keys(data).length > 0) {
            Object.keys(data).map((item) => {
              let list = data[item] || []

              if (list.length > 0) {
                list.map((item2) => {
                  item2['isEdit'] = false
                })
              }
            })

            that.menuLayerData = data
          }
        })
        .catch(() => {})
    },
    getGeoFenceListHandle() {
      let that = this
      let mapInstance = that.mapInstance

      if (mapInstance) {
        let mapBounds = mapInstance.getBounds().toString().split(';')
        let mapRightTop = mapBounds[1].split(',')
        let mapLeftBottom = mapBounds[0].split(',')
        let mapLeftTopLat = mapRightTop[1] || 39.9815924582
        let mapLeftTopLng = mapLeftBottom[0] || 116.3023402405
        let mapRightBottomLat = mapLeftBottom[1] || 39.895118871
        let mapRightBottomLng = mapRightTop[0] || 116.4990234375
        let params = {
          pageSize: MAX_PAGE_SIZE,
          pageNumber: 1,
          latitude1: mapLeftTopLat,
          latitude2: mapRightBottomLat,
          longitude1: mapLeftTopLng,
          longitude2: mapRightBottomLng,
          layerCodeList: [...new Set(that.checkedFenceLayerList)],
        }

        that.fetch
          .post('geofenceFenceList', params)
          .then((res) => {
            let { data = [] } = res
            that.processGeoFenceListHandle(data, false)
          })
          .catch(() => {
            that.processGeoFenceListHandle([], false)
          })
      }
    },
    processGeoFenceListHandle(list = [], flag = false) {
      let that = this
      let listLen = list.length
      let mapInstance = that.mapInstance
      let polygonList = []

      if (listLen > 0) {
        if (that.markers.length > 0) {
          that.markers = []
        }

        for (let i = 0; i < listLen; i++) {
          let obj = list[i] || {}
          let region =
            typeof obj.region === 'string' ? JSON.parse(obj.region || '{}') : obj.region || {}
          let coordinates = region.coordinates || []
          let coordinatesLen = coordinates.length

          if (coordinatesLen > 0) {
            let polygonType = region.type || 'Polygon'

            for (let j = 0; j < coordinatesLen; j++) {
              let geoFencePath =
                polygonType === 'MultiPolygon' ? coordinates[j][0] || [] : coordinates[0] || []

              if (geoFencePath.length > 0) {
                let item = {
                  path: geoFencePath,
                  events: {
                    click: (e) => {
                      let polygon = e.target
                      let options = polygon.getOptions() || {}
                      let extData = polygon.getExtData() || {}
                      let layerCode = extData.layerCode || ''
                      let isSelected = options.fillColor === colorMap['selected']

                      that.fenceInfoDrawerVisible = false

                      if (layerCode && layerCode !== that.selectedFenceLayer.code) {
                        if (!that.isAddFence) {
                          that.$message({
                            type: 'error',
                            message:
                              '当前围栏所属图层处于非编辑状态下，只能点击鼠标右键查看围栏信息！',
                            showClose: true,
                          })
                        }

                        return false
                      }

                      let color = ''
                      let opacity = 0.2

                      if (isSelected) {
                        color = colorMap['default']
                        opacity = 0.2

                        that.selectedGeoFenceListHandle('delete', extData)
                      } else {
                        color = colorMap['selected']
                        opacity = 0.4

                        that.selectedGeoFenceListHandle('add', extData)
                      }

                      polygon.setOptions({
                        fillColor: color,
                        fillOpacity: opacity,
                        strokeColor: color,
                      })
                    },
                    dblclick: () => {
                      console.log('dblclick polygon')
                    },
                    rightclick: (e) => {
                      that.initMapPolygonStyleHandle()
                      that.initSelectedGeoFenceListHandle()

                      let polygon = e.target
                      let options = polygon.getOptions() || {}
                      let extData = polygon.getExtData() || {}
                      let layerCode = extData.layerCode || ''
                      let layerData = that.menuLayerData || {}
                      let isSelected = options.fillColor === colorMap['selected']
                      let selectedLayer = {}

                      that.mouseToolInstance && that.mouseToolInstance.close(false)

                      if (!isSelected) {
                        let color = colorMap['selected']
                        let opacity = 0.4

                        polygon.setOptions({
                          fillColor: color,
                          fillOpacity: opacity,
                          strokeColor: color,
                        })
                      }

                      Object.keys(layerData).length > 0 &&
                        Object.keys(layerData).map((item) => {
                          let list = layerData[item] || []
                          let listLen = list.length

                          for (let i = 0; i < listLen; i++) {
                            let obj = list[i] || {}
                            let code = obj.code || ''

                            if (layerCode && layerCode === code) {
                              selectedLayer = obj

                              break
                            }
                          }
                        })

                      that.isEditFence = layerCode && layerCode === that.selectedFenceLayer.code
                      that.fenceFormData = {
                        name: extData.name || '',
                        explain: extData.explain || '',
                        cityCode: extData.cityCode || '',
                      }
                      that.rightClickFenceData = extData
                      that.fenceInfoDrawerType = 'show'
                      that.rightClickFenceLayer = selectedLayer
                      that.fenceInfoDrawerVisible = true
                      that.rightClickSelectedPolygon = polygon
                    },
                  },
                  extData: obj,
                  fillColor: colorMap['default'],
                  fillOpacity: 0.2,
                  strokeColor: colorMap['default'],
                  strokeWeight: 2,
                  strokeOpacity: 1,
                }

                polygonList.push(item)
              }
            }
          }
        }
      }

      if (flag) {
        if (polygonList.length > 0) {
          that.polygons = [...that.polygons, ...polygonList]
        }
      } else {
        that.polygons = polygonList

        if (mapInstance) {
          setTimeout(() => {
            mapInstance.setFitView()
          }, 1)
        }
      }
    },
    removeOverlaysHandle(type = '') {
      let mapInstance = this.mapInstance

      if (mapInstance) {
        let overlays = type ? mapInstance.getAllOverlays(type) : mapInstance.getAllOverlays() || []
        let overlaysLen = overlays.length

        if (overlaysLen > 0) {
          for (let i = 0; i < overlaysLen; i++) {
            let overlay = overlays[i] || {}

            mapInstance.remove([overlay])
          }
        }
      }
    },
    errorDialogConfirmHandle() {
      let that = this

      switch (that.dialogErrorType) {
        case 1:
        case 4:
          // that.removeOverlaysHandle('text')
          that.mouseToolInstance && that.mouseToolInstance.close(true)

          that.dialogErrorType = 0
          that.errorDialogVisible = false
          that.fenceInfoDrawerVisible = false

          break
        case 2:
        case 3:
        default:
          that.dialogErrorType = 0
          that.errorDialogVisible = false
          that.fenceInfoDrawerVisible = false

          break
      }
    },
    initMapPolygonStyleHandle() {
      let mapInstance = this.mapInstance

      if (mapInstance) {
        let polygons = mapInstance.getAllOverlays('polygon') || []
        let polygonsLen = polygons.length

        if (polygonsLen > 0) {
          for (let i = 0; i < polygonsLen; i++) {
            let polygon = polygons[i] || {}
            let options = polygon.getOptions() || {}
            let isSelected = options.fillColor === colorMap['selected']

            if (isSelected) {
              let color = colorMap['default']

              polygon.setOptions({
                fillColor: color,
                fillOpacity: 0.2,
                strokeColor: color,
              })
            }
          }
        }
      }
    },
    initSelectedGeoFenceListHandle() {
      this.selectedGeoFenceList = []
    },
    amapSearchResultHandle(pois) {
      let that = this
      let poisLen = pois.length

      if (poisLen > 0) {
        let latSum = 0
        let lngSum = 0

        that.polygons = []

        pois.forEach((poi) => {
          let { lng, lat } = poi

          lngSum += lng
          latSum += lat

          that.markers.push([lng, lat])
        })

        let center = {
          lng: lngSum / poisLen,
          lat: latSum / poisLen,
        }
        let centerCoordinate = [center.lng, center.lat]

        that.center = centerCoordinate
      }
    },
    selectedGeoFenceListHandle(type = '', extData = {}) {
      let that = this

      if (type === '' || Object.keys(extData) < 1) {
        return false
      }

      let list = that.selectedGeoFenceList || []
      let listLen = list.length
      let fenceId = extData.id || ''

      if (type === 'add') {
        let flag = true

        for (let i = 0; i < listLen; i++) {
          let obj = list[i] || {}
          let tempFenceId = obj.id || ''

          if (fenceId && fenceId === tempFenceId) {
            flag = false

            break
          }
        }

        flag && list.push(extData)
      } else if (type === 'delete') {
        for (let i = 0; i < listLen; i++) {
          let obj = list[i] || {}
          let tempFenceId = obj.id || ''

          if (fenceId && fenceId === tempFenceId) {
            list.splice(i, 1)

            break
          }
        }
      }

      that.selectedGeoFenceList = list
    },
    addFenceHandle() {
      let that = this
      if (!that.isCanAddFence) {
        that.$message({
          type: 'error',
          duration: 5000,
          message: '请点击图层右侧编辑按钮切换到编辑状态',
          showClose: true,
        })
        return
      }

      let mouseToolInstance = that.mouseToolInstance

      if (mouseToolInstance) {
        that.$message({
          type: 'success',
          duration: 5000,
          message: '点击开始绘制形状，双击结束绘制形状！',
          showClose: true,
        })

        mouseToolInstance.close(true)

        let ruleInstance = mouseToolInstance.rule({
          lineOptions: {
            strokeStyle: 'solid',
            strokeColor: colorMap['line2'],
            strokeWeight: 2,
            strokeOpacity: 1,
          },
          midMarkerOptions: {
            icon: new AMap.Icon({
              size: new AMap.Size(19, 31),
              image: iconMap['marker_mid'],
              imageSize: new AMap.Size(19, 31),
            }),
            offset: new AMap.Pixel(-9, -31),
          },
          endMarkerOptions: {
            icon: new AMap.Icon({
              size: new AMap.Size(19, 31),
              image: iconMap['marker_end'],
              imageSize: new AMap.Size(19, 31),
            }),
            offset: new AMap.Pixel(-9, -31),
          },
          startMarkerOptions: {
            icon: new AMap.Icon({
              size: new AMap.Size(19, 31),
              image: iconMap['marker_start'],
              imageSize: new AMap.Size(19, 31),
            }),
          },
        })

        ruleInstance.on('addnode', function (e) {
          console.log('ruleInstance addnode e: ', e)
        })
        ruleInstance.off('end', that.updateLineNodeHandle)
        ruleInstance.off('removenode', that.updateLineNodeHandle)
        ruleInstance.on('end', that.updateLineNodeHandle)
        ruleInstance.on('removenode', that.updateLineNodeHandle)

        that.isAddFence = true
        that.isEditFence = true
        that.isOperateFence = true
        that.fenceInfoDrawerVisible = false
      }
    },
    addFenceHandle2() {
      let that = this
      if (!that.isCanAddFence) {
        that.$message({
          type: 'error',
          duration: 5000,
          message: '请点击图层右侧编辑按钮切换到编辑状态',
          showClose: true,
        })
        return
      }
      if (that.rangingToolInstance) {
        that.$message({
          type: 'success',
          duration: 5000,
          message: '点击开始绘制形状，双击结束绘制形状！',
          showClose: true,
        })

        that.removeOverlaysHandle('text')
        that.removeOverlaysHandle('polyline')
        that.rangingToolInstance.turnOn()

        that.isAddFence = true
        that.isEditFence = true
        that.isOperateFence = true
        that.fenceInfoDrawerVisible = false
      }
    },
    deleteFenceHandle() {
      let that = this

      if (!that.isCanDeleteFence) {
        that.$message({
          type: 'error',
          duration: 5000,
          message: '请点击图层右侧编辑按钮切换到编辑状态',
          showClose: true,
        })
        return
      }
      let list = that.selectedGeoFenceList || []
      let listLen = list.length

      if (listLen > 0) {
        let fenceList = []

        for (let i = 0; i < listLen; i++) {
          let obj = list[i] || {}
          let fenceId = obj.id || ''
          let fenceName = obj.name || ''

          fenceList.push(fenceId + ': ' + fenceName)
        }

        that.isOperateFence = true
        that.deleteFencePromptText =
          '您确定要删除选中的' + listLen + '个【' + fenceList.join('; ') + '】围栏吗？'
        that.fenceInfoDrawerVisible = false
        that.deleteFenceDialogVisible = true
      } else {
        that.$message({
          type: 'error',
          message: '请点击鼠标左键选中（可同时选中多个）要删除的围栏！',
          showClose: true,
        })
      }
    },
    updateLineNodeHandle(e) {
      let that = this
      let points = e.points || []
      let latitude = 39.910993
      let longitude = 116.397617
      let pointsLen = points.length
      let coordinates = []

      if (pointsLen > 2) {
        for (let i = 0; i < pointsLen; i++) {
          let point = points[i] || {}

          latitude = point.getLat() || 39.910993
          longitude = point.getLng() || 116.397617
          coordinates.push([longitude, latitude])
        }

        let selectedLayerCode = that.selectedFenceLayer.code || ''
        let lastTempCoordinate = coordinates[coordinates.length - 1]
        let firstTempCoordinate = coordinates[0]

        if (
          firstTempCoordinate[0] !== lastTempCoordinate[0] ||
          firstTempCoordinate[1] !== lastTempCoordinate[1]
        ) {
          coordinates.push(firstTempCoordinate)
        }

        if (selectedLayerCode !== '') {
          let params = {
            geojson: JSON.stringify({
              type: 'Polygon',
              coordinates: [coordinates],
            }),
            layerCode: selectedLayerCode,
          }

          that.fetch
            .post('geofenceFencePreCheck', params)
            .then((res) => {
              let { data } = res

              that.dialogErrorType = 0
              that.errorDialogVisible = false
              that.fenceInfoDrawerVisible = true

              if (data && data.mbkSpockCity) {
                that.fenceFormData.cityCode = data.mbkSpockCity.regionId || ''
                that.fenceFormData.cityName = data.mbkSpockCity.name || ''
              } else {
                that.fenceFormData.cityCode = ''
                that.fenceFormData.cityName = ''
              }
            })
            .catch((err) => {
              that.dialogErrorType = 4
              that.errorDialogVisible = true
              that.dialogErrorMessage = err.message || '接口异常，请重试！'
              that.fenceInfoDrawerVisible = false
            })
        }

        that.fenceCoordinates = coordinates
        that.fenceInfoDrawerType = 'add'
        that.mouseToolInstance && that.mouseToolInstance.close(false)
      } else {
        that.dialogErrorType = 1
        that.dialogErrorMessage = '当前添加围栏不合法（至少要添加3个点），请您重画！'
        that.errorDialogVisible = true
      }
    },
    resetFormHandle() {
      this.fenceFormData = {
        name: '',
        explain: '',
        cityCode: '',
        cityName: '',
      }
    },
    // resetFormHandle (formName = 'fenceForm') {
    //   let form = this.$refs[formName]

    //   form && form.resetFields()
    // },
    fenceCancelHandle(isCancel = true) {
      let that = this

      if (isCancel && that.fenceInfoDrawerType === 'add') {
        that.isAddFence = false
        // that.removeOverlaysHandle('text')
        that.mouseToolInstance && that.mouseToolInstance.close(true)
      }

      that.resetFormHandle()
      that.initMapPolygonStyleHandle()

      that.rightClickFenceData = {}
      that.fenceInfoDrawerType = 'add'
      that.fenceInfoDrawerVisible = false
    },
    fenceSubmitHandle(formName = 'fenceForm') {
      let that = this

      if (that.isEditFence) {
        let selectedLayerCode = that.selectedFenceLayer.code || ''

        if (selectedLayerCode === '') {
          that.$message({
            type: 'error',
            duration: 5000,
            message: '请点击图层右侧编辑按钮切换到编辑状态！',
            showClose: true,
          })

          return false
        }

        that.$refs[formName].validate((valid) => {
          if (valid) {
            that
              .$confirm('确定要提交保存吗？')
              .then(() => {
                let formData = that.fenceFormData || {}
                let cityCode = formData.cityCode || ''
                let fenceName = formData.name || ''
                let fenceExplain = formData.explain || ''

                if (fenceName === '') {
                  that.$message.error(`请填写围栏名称！`)

                  return false
                }

                if (cityCode === '') {
                  that.$message.error(`请选择所属区域！`)

                  return false
                }

                that.loading = true

                let params = {
                  name: fenceName,
                  state: 0,
                  explain: fenceExplain,
                  cityCode: cityCode,
                  regionId: cityCode,
                  layerCode: selectedLayerCode,
                }

                if (that.fenceInfoDrawerType === 'add') {
                  params['region'] = JSON.stringify({
                    type: 'Polygon',
                    coordinates: [that.fenceCoordinates],
                  })

                  that.fetch
                    .post('geofenceFenceAdd', params)
                    .then((res) => {
                      let { data, message } = res

                      if (data) {
                        that.processGeoFenceListHandle([data], true)
                      }

                      that.$message.success(message || '围栏添加成功！')

                      that.resetFormHandle()

                      that.loading = false
                      that.isAddFence = false
                      that.isOperateFence = false
                      that.fenceInfoDrawerVisible = false
                      that.mouseToolInstance && that.mouseToolInstance.close(true)
                    })
                    .catch((err) => {
                      that.dialogErrorType = 0
                      that.dialogErrorMessage = err.message || '围栏添加失败！'
                      that.errorDialogVisible = true

                      that.resetFormHandle()

                      that.loading = false
                      that.isAddFence = false
                      that.isOperateFence = false
                      // that.fenceInfoDrawerVisible = false
                      that.mouseToolInstance && that.mouseToolInstance.close(true)
                    })
                } else {
                  let fenceId = that.rightClickFenceData.id || ''

                  if (fenceId === '') {
                    that.$message.error(`围栏ID缺失！`)
                    that.loading = false

                    return false
                  }

                  params['id'] = fenceId
                  params['region'] = that.rightClickFenceData.region || '{}'

                  that.fetch
                    .post('geofenceFenceUpdate', params)
                    .then((res) => {
                      let { data, message } = res

                      let fenceData = data || {}

                      if (that.rightClickSelectedPolygon && Object.keys(fenceData).length > 0) {
                        that.rightClickSelectedPolygon.setExtData(fenceData)
                      }

                      that.$message.success(message || '围栏更新成功！')

                      that.resetFormHandle()

                      that.loading = false
                      that.fenceInfoDrawerVisible = false
                      that.mouseToolInstance && that.mouseToolInstance.close(true)
                    })
                    .catch((err) => {
                      that.dialogErrorType = 0
                      that.dialogErrorMessage = err.message || '围栏更新失败！'
                      that.errorDialogVisible = true
                      that.rightClickSelectedPolygon = null

                      that.resetFormHandle()

                      that.loading = false
                      that.fenceInfoDrawerVisible = false
                      that.mouseToolInstance && that.mouseToolInstance.close(true)
                    })
                }
              })
              .catch(() => {})
          } else {
            return false
          }
        })
      } else {
        that.fenceCancelHandle(true)
      }
    },
    editFenceToggleHandle(code = '') {
      let that = this
      let data = that.menuLayerData || {}

      Object.keys(data).length > 0 &&
        Object.keys(data).map((item, index) => {
          let list = data[item] || []

          if (list.length > 0) {
            list.map((item2) => {
              let tempCode = item2.code || ''

              if (tempCode && code === tempCode) {
                let flag = !item2['isEdit']
                let codeList = [...new Set(that.checkedFenceLayerList)] || []
                let checkedIndex = codeList.indexOf(tempCode)

                item2['isEdit'] = flag
                that.$set(item2, 'isEdit', flag)

                if (flag) {
                  that.isCanAddFence = index === 1 && !!item2.addFence
                  that.isCanDeleteFence = index === 1 && !!item2.delFence
                  that.selectedFenceLayer = item2

                  if (checkedIndex === -1) {
                    that.checkedFenceLayerList.push(tempCode)
                  }
                } else {
                  if (checkedIndex !== -1) {
                    that.isCanAddFence = false
                    that.isCanDeleteFence = false
                    that.selectedFenceLayer = {}
                    // that.checkedFenceLayerList.splice(checkedIndex, 1)
                  }
                }
              } else {
                item2['isEdit'] = false
                that.$set(item2, 'isEdit', false)
              }
            })
          }
        })

      if (that.checkedFenceLayerList.length > 0) {
        that.getGeoFenceListHandle()
      } else {
        that.processGeoFenceListHandle([], false)
      }
    },
    checkFenceLayerChangeHandle(checkedList) {
      let that = this
      let selectedLayerCode = that.selectedFenceLayer.code || ''

      checkedList = checkedList || []

      that.mouseToolInstance && that.mouseToolInstance.close(true)

      if (selectedLayerCode && checkedList.indexOf(selectedLayerCode) === -1) {
        that.isCanAddFence = false
        that.isCanDeleteFence = false
        that.selectedFenceLayer = {}
        that.editFenceToggleHandle('')
      } else {
        if (checkedList.length > 0) {
          that.getGeoFenceListHandle()
        } else {
          that.processGeoFenceListHandle([], false)
        }
      }
    },
    deleteFenceConfirmHandle() {
      let that = this
      let fenceList = that.selectedGeoFenceList || []
      let fenceListLen = fenceList.length

      if (fenceListLen > 0) {
        let mapInstance = that.mapInstance

        if (mapInstance) {
          let polygons = mapInstance.getAllOverlays('polygon') || []
          let polygonsLen = polygons.length
          let fenceIdList = []

          if (polygonsLen > 0) {
            for (let i = 0; i < fenceListLen; i++) {
              let fence = fenceList[i] || {}
              let layerCode = fence.layerCode || ''

              if (layerCode && layerCode === that.selectedFenceLayer.code) {
                fenceIdList.push(fence.id)
              }
            }
          }

          if (fenceIdList.length > 0) {
            let params = {
              geoFenceId: fenceIdList.join(','),
            }

            that.fetch
              .post('geofenceFenceDelete', params)
              .then((res) => {
                let { data, message } = res
                let list = data || []
                let listLen = list.length
                let failedGeoFenceList = []
                let deletedGeoFenceList = []

                if (listLen > 0) {
                  for (let j = 0; j < fenceListLen; j++) {
                    let obj = fenceList[j] || {}
                    let fenceId = obj.id || ''

                    if (fenceId) {
                      if (list.indexOf(fenceId) === -1) {
                        deletedGeoFenceList.push(obj)
                      } else {
                        failedGeoFenceList.push(obj)
                      }
                    }
                  }
                } else {
                  deletedGeoFenceList = fenceList
                }

                let deletedGeoFenceListLen = deletedGeoFenceList.length

                if (deletedGeoFenceListLen > 0) {
                  for (let k = 0; k < deletedGeoFenceListLen; k++) {
                    let item = deletedGeoFenceList[k] || {}
                    let deletedFenceId = item.id || ''

                    if (deletedFenceId) {
                      for (let l = 0; l < polygonsLen; l++) {
                        let polygon = polygons[l] || {}
                        let extData = polygon.getExtData() || {}
                        let tempFenceId = extData.id || ''

                        if (tempFenceId === deletedFenceId) {
                          mapInstance.remove([polygon])
                        }
                      }
                    }
                  }
                }

                that.selectedGeoFenceList = failedGeoFenceList
                that.$message.success(message || '围栏删除成功！')
                that.isOperateFence = false
                that.deleteFenceDialogVisible = false
              })
              .catch((err) => {
                let list = err.data || []
                let listLen = list.length
                let errorMessage = ''
                let failedGeoFenceList = []
                let deletedGeoFenceList = []

                if (listLen > 0) {
                  for (let j = 0; j < fenceListLen; j++) {
                    let obj = fenceList[j] || {}
                    let fenceId = obj.id || ''

                    if (fenceId) {
                      if (list.indexOf(fenceId) === -1) {
                        deletedGeoFenceList.push(obj)
                      } else {
                        failedGeoFenceList.push(obj)
                      }
                    }
                  }

                  errorMessage = '围栏（' + list.join('、') + '）删除失败！'
                } else {
                  errorMessage = err.message || '围栏删除失败！'
                  deletedGeoFenceList = fenceList
                }

                let deletedGeoFenceListLen = deletedGeoFenceList.length

                if (deletedGeoFenceListLen > 0) {
                  for (let k = 0; k < deletedGeoFenceListLen; k++) {
                    let item = deletedGeoFenceList[k] || {}
                    let deletedFenceId = item.id || ''

                    if (deletedFenceId) {
                      for (let l = 0; l < polygonsLen; l++) {
                        let polygon = polygons[l] || {}
                        let extData = polygon.getExtData() || {}
                        let tempFenceId = extData.id || ''

                        if (tempFenceId === deletedFenceId) {
                          mapInstance.remove([polygon])
                        }
                      }
                    }
                  }
                }

                that.isOperateFence = false
                that.dialogErrorType = 0
                that.dialogErrorMessage = errorMessage
                that.errorDialogVisible = true
                that.selectedGeoFenceList = failedGeoFenceList
                that.deleteFenceDialogVisible = false
              })
          } else {
            that.$message({
              type: 'error',
              message: '当前选中要删除的围栏所属图层属于非编辑状态，请确认后再操作！',
              showClose: true,
            })
          }
        }
      } else {
        that.$message({
          type: 'error',
          message: '请点击鼠标左键选中（可同时选中多个）要删除的围栏！',
          showClose: true,
        })
      }
    },
  },
}
</script>

<style scoped lang="scss">
#page-geofence {
  position: relative;

  .fence-panel {
    z-index: 199;
    box-shadow: 0 0 12px rgba(83, 88, 95, 0.6);
    border-radius: 2px;
    -webkit-box-shadow: 0 0 12px rgba(83, 88, 95, 0.6);
  }

  .fence-query-panel {
    top: 0;
    left: 0;
    width: 300px;
    position: absolute;
  }

  .search-input-box {
    width: 300px;
  }
}

.geo-fence-amap {
  height: 85vh;
}

.tool-btns-panel {
  top: 300px;
  left: 0;
  position: absolute;
}

.tool-btns-panel ul li {
  color: #292929;
  width: 32px;
  height: 32px;
  cursor: pointer;
  display: block;
  font-size: 14px;
  text-align: center;
  background: #ccc;
  line-height: 32px;
  border-radius: 2px;
  margin-bottom: 16px;
}

.tool-btns-panel ul li.active {
  background: #ffd100;
}

.tool-btn {
  padding: 6px;
  font-size: 20px;
}

.no-border {
  border-top: none;
  border-bottom: none;
}

.right-layer-panel {
  top: 0;
  right: 0;
  width: 248px;
  padding: 0 12px;
  position: absolute;
  background-color: #fff;
}

.fence-layer-item {
  position: relative;

  .el-checkbox {
    width: 184px;
    overflow: hidden;
    white-space: nowrap;
    margin-right: 0;
    text-overflow: ellipsis;
  }

  .el-button {
    top: 0;
    right: 0;
    padding: 4px;
    position: absolute;
  }

  .el-button.active {
    color: #292929;
    border-color: #ffd100;
    background-color: #ffd100;
  }
}

.drawer-content {
  padding: 0 20px;
  line-height: 1.5;
  word-wrap: break-word;

  .select {
    width: 296px;
  }

  .drawer-footer {
    text-align: right;
    padding-top: 12px;
  }
}
</style>

<style lang="scss">
.fence-panel .el-checkbox__label {
  display: inline;
}
.fence-layer-item-wrap .el-collapse-item__content {
  max-height: 300px;
  overflow-y: auto;
}
.fence-panel .el-collapse-item__content {
  padding-bottom: 0;
}
#page-geofence .amap-maptypecontrol {
  top: 0;
  right: 254px;
  position: absolute;
}
</style>
